import "./Faq.css";
import { FaPlus, FaMinus } from "react-icons/fa";
import { useSelector } from "react-redux";
import React, { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

export const Faq = () => {
  const faqData = useSelector((state) => state.gallery?.faq);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="faq-container" data-aos="fade-up">
      <h1 data-aos="zoom-in">
        Frequently Asked Questions <span>(FAQ)</span>
      </h1>

      <div className="faq-list">
        <p className="subheading" data-aos="fade-up">
          Have any questions? Read popular answers below
        </p>

        {faqData.list.map((item, idx) => (
          <div
            key={idx}
            className={`faq-item ${activeIndex === idx ? "active" : ""}`}
            data-aos="fade-up"
            data-aos-delay={idx * 100}
            onClick={() =>
              setActiveIndex((prevIndex) => (prevIndex === idx ? null : idx))
            }
          >
            <div className="faq-question">
              {item.question}
              <span className="icon">
                {activeIndex === idx ? <FaMinus /> : <FaPlus />}
              </span>
            </div>
            {activeIndex === idx && (
              <div className="faq-answer" data-aos="fade-in">
                {item.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
